import styled from 'styled-components';

export const StyledProductHeading = styled.h2`
  display: inline-block;
  margin-bottom: 0;
  margin-right: 1em;
`;
